export default __webpack_public_path__ + "static/photo-arico-06fbf92c5a0a02f4e54905ed4ca455c5.jpg";